import { TokenExpirancyKey, TokenKey } from "./config";
import process from "@/utils/process";

export default class AuthStorage {
  static setToken(token: string | null, expires_in: number = 0) {
    if (process.server) return;

    if (token) {
      localStorage.setItem(TokenKey, token);
      localStorage.setItem(
        TokenExpirancyKey,
        expires_in * 0.9 + Date.now() + ""
      );
    }
  }

  static deleteToken() {
    if (process.server) return;

    localStorage.removeItem(TokenKey);
    localStorage.removeItem(TokenExpirancyKey);
  }

  static get token() {
    if (process.server) return;
    return localStorage.getItem(TokenKey) || null;
  }

  static get isExpired() {
    if (process.server) return;

    const expires_in = localStorage.getItem(TokenExpirancyKey) || 0;
    return +expires_in < Date.now();
  }

  static isExpiredWithMargin(margin = 0) {
    if (process.server) return;

    if (!margin) {
      margin = +useRuntimeConfig().public.JWT_TTL || 10;
      margin = margin * 0.1 * 1000 * 60;
    }

    const expires_in = localStorage.getItem(TokenExpirancyKey) || 0;
    return (+expires_in + margin) < Date.now();
  }

  static check() {
    return AuthStorage.token && !AuthStorage.isExpiredWithMargin();
  }
}
